'use client'
import { type FC, memo, type ReactNode } from 'react'
import styled from 'styled-components'
import type { TypeCmsProductsByCategoryList } from '@/schema'
import { SectionFilters } from './SectionFilters'
import { SectionContact } from './SectionContact'
import { SectionTwoCols } from '@/components/SectionTwoCols'
import { CortinaControler } from './commons/CortinaControler'
import { useMount } from '@/hooks'

type Props = {
  data: {
    filters: TypeCmsProductsByCategoryList['filters']
  }
  children: ReactNode
}


const cols = [
  {
    name: 'Configurator',
    pathname: '/configurator',
    src: '/images/two-cols_configurator.jpg'
  },
  {
    name: 'Downloads',
    pathname: '/downloads',
    src: '/images/two-cols_downloads.jpg'
  }
]


export const MainProductsList: FC<Props> = memo(({ data, children }) => {
  const isMount  = useMount()

  return isMount && (
    <Main>
      {data?.filters?.length > 0 && <SectionFilters data={data?.filters} />}
      {children}
      <SectionTwoCols cols={cols} className={'s-wrapper'}/>
      <SectionContact/>
      <CortinaControler />
    </Main>
  )
})

const Main = styled.main`
  width: 100vw;
  width: 100dvw;
`
